module.exports = __webpack_public_path__ + "static/media/team_04.bc321512.jpg";